var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 22,
    viewBox: "0 0 80 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.2957V0.141031H0.0282064L10.9158 15.5699L9.61833 15.2878L20.4495 0.141031H20.506V21.2957H17.5161V6.93874L17.7135 8.49009L10.1543 19.1803H10.0978L2.39753 8.49009L2.90524 7.07977V21.2957H0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6353 0.817983H32.6534V21.2957H29.6353V0.817983Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3925 0.817983C48.4643 0.817983 49.4515 0.968416 50.3541 1.26928C51.2755 1.55134 52.0559 1.96504 52.6952 2.51036C53.3534 3.05568 53.8611 3.73263 54.2184 4.54121C54.5945 5.33098 54.7825 6.25239 54.7825 7.30542C54.7825 8.114 54.6603 8.91318 54.4158 9.70296C54.1714 10.4927 53.7765 11.2073 53.2312 11.8466C52.6858 12.486 51.9713 13.0031 51.0875 13.398C50.2037 13.7741 49.1036 13.9621 47.7874 13.9621H44.7975V21.2957H41.7794V0.817983H47.3925ZM47.7309 11.0851C48.5019 11.0851 49.1413 10.9628 49.649 10.7184C50.1755 10.4739 50.5798 10.1731 50.8618 9.81578C51.1627 9.4397 51.3695 9.04481 51.4824 8.63112C51.614 8.19862 51.6798 7.78493 51.6798 7.39004C51.6798 7.01396 51.614 6.61907 51.4824 6.20538C51.3695 5.79169 51.1627 5.3968 50.8618 5.02072C50.5798 4.64463 50.1943 4.33436 49.7054 4.08991C49.2165 3.84545 48.6147 3.72323 47.9002 3.72323H44.7975V11.0851H47.7309ZM51.2003 12.8339L56.5031 21.2957H53.0055L47.6181 12.9185L51.2003 12.8339Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8352 21.2957L70.833 0H71.0022L80 21.2957H76.5588L70.015 4.71045L72.1869 3.27193L64.7968 21.2957H61.8352Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white-logo.cd8f97a0e21195ac7f0dd9cca1f2916c.svg";
export { ForwardRef as ReactComponent };